"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Response = _interopRequireDefault(require("../Http/Response"));

var _Cache = _interopRequireDefault(require("../Tools/Cache"));

var _Exception = require("../Exceptions/Exception");

var _ExceptionCode = require("../Exceptions/ExceptionCode");

var _apolloBoost = require("apollo-boost");

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _apolloLinkContext = require("apollo-link-context");

var _EnvironmentVariables = _interopRequireDefault(require("../Tools/EnvironmentVariables"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const cache = new _Cache.default(86400); // 24 Hora

const ApolloCache = new _apolloCacheInmemory.InMemoryCache();

class Request {
  static async request(type, data) {
    let globalFetch = null;

    if (typeof window === 'undefined') {
      globalFetch = require('node-fetch');
    } else {
      globalFetch = fetch;
    }

    let serviceAddress = await Request.loadServiceAddress(data.service || 'storage', 'v1');
    let headerLink = (0, _apolloLinkContext.setContext)((_, {
      headers
    }) => {
      return {
        headers: { ...headers,
          ...data.headers
        }
      };
    });
    let httpClient = new _apolloBoost.ApolloClient({
      link: headerLink.concat(new _apolloBoost.HttpLink({
        uri: serviceAddress,
        fetch: globalFetch
      })),
      cache: ApolloCache,
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'ignore'
        },
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all'
        }
      }
    });
    let sendData = {
      variables: data.vars
    };

    if (type == 'query') {
      sendData.query = data.data;
    } else if (type == 'mutate') {
      sendData.mutation = data.data;
    }

    return httpClient[type](sendData).then(response => {
      return new _Response.default(response.data || null, response.code || 200, response.errors || []);
    }).catch(error => {
      return new _Response.default(null, 500, error.graphQLErrors.map(m => m.message));
    });
  }

  static query(data) {
    return this.request('query', {
      service: data.service || 'storage',
      headers: data.headers || { ...Request.generalHeaders
      },
      data: (0, _apolloBoost.gql)`${data.data}`,
      vars: data.vars || {}
    });
  }

  static mutate(data) {
    return this.request('mutate', {
      service: data.service || 'storage',
      headers: data.headers || { ...Request.generalHeaders
      },
      data: (0, _apolloBoost.gql)`${data.data}`,
      vars: data.vars || {}
    });
  }

  static setHeader(header, value) {
    this.generalHeaders[header] = value;
  }

  static setHeaders(headersArray = []) {
    Object.keys(headersArray).map(key => {
      this.setHeader(key, headersArray[key]);
    });
  }

  static loadServiceAddress(serviceName, version) {
    let servicesEndpoint = null;
    let stage = null;

    if (process.env.VUE_APP_SERVICES_ENDPOINT_BASE) {
      servicesEndpoint = process.env.VUE_APP_SERVICES_ENDPOINT_BASE;
    } else if (process.env.REACT_APP_SERVICES_ENDPOINT_BASE) {
      servicesEndpoint = process.env.REACT_APP_SERVICES_ENDPOINT_BASE;
    } else if (process.env.ECS_SERVICES_ENDPOINT_BASE) {
      servicesEndpoint = process.env.ECS_SERVICES_ENDPOINT_BASE;
    } else if (_EnvironmentVariables.default.SERVICES_ENDPOINT_BASE) {
      servicesEndpoint = _EnvironmentVariables.default.SERVICES_ENDPOINT_BASE;
    }

    if (process.env.VUE_APP_STAGE) {
      stage = process.env.VUE_APP_STAGE;
    } else if (process.env.REACT_APP_STAGE) {
      stage = process.env.REACT_APP_STAGE;
    } else if (process.env.STAGE) {
      stage = process.env.STAGE;
    }

    if (servicesEndpoint) {
      return `${servicesEndpoint.replace('{SERVICE}', serviceName).replace('{STAGE}', stage).toLowerCase()}/${version}`;
    } else {
      throw new _Exception.Exception(_ExceptionCode.ExceptionCode.ENVIRONMENT_ENDPOINT_UNDEFINED);
    }
  }

}

exports.default = Request;

_defineProperty(Request, "generalHeaders", []);